import { useDataStore } from "../contexts/DataStoreContext";

import { Button, Modal } from "cai-fusion";
import { useEffect, useState } from "react";

const DeleteDataStoreModal = ({ isHidden, onClose, clickOutsideToClose }) => {
    const { dataStores, dataStoreId, deleteDataStore } = useDataStore();
    const [dataStoreName, setDataStoreName] = useState("");

    useEffect(() => {
        if(!isHidden){
            setDataStoreName(dataStores.filter((dataStore) => dataStore.id === dataStoreId)[0].name);
        }
    }, [isHidden])

    return (
        <Modal
            id="delete-modal"
            isHidden={isHidden}
            clickOutsideToClose={clickOutsideToClose}
            title="Delete Data Collection"
            onClose={(e) => {
                onClose();
                e.preventDefault();
            }}
            actions={
                <>
                    <Button outline onClick={(e) => { e.preventDefault(); onClose(); }} children="Cancel"/>
                    <Button danger onClick={(e) => { e.preventDefault(); deleteDataStore(); onClose(); }} children="Delete Data Collection"/>
                </>
            }
        >
            <div className="l-row">
                <div className="l-one-col">
                    <p><strong>{`Are you sure you want to delete ${dataStoreName ? (`"` + dataStoreName + `"`) : "this data collection"}?`}</strong></p>
                    <p>Deleting a data collection can't be undone, so think carefully! :) </p>
                </div>
            </div>
        </Modal>
    )
}

export default DeleteDataStoreModal;